export const pl = {
  'app.components.dashboard.title': 'Panel kontrolny',
  'app.components.order-selector.title': 'Pokaż otwarte zamówienia:',
  'app.components.order-selector.today': 'Dzisiaj',
  'app.components.order-selector.tomorrow': 'Jutro',
  'app.components.order-selector.later': 'Później',
  'app.components.hamburger-menu.title': 'Aktywne zamówienia',
  'app.components.hamburger-menu.aria-label': 'Menu',
  'app.components.search-button.aria-label': 'Przycisk wyszukiwania',
  'app.components.product-item-controls.accept': 'Akceptuj',
  'app.components.product-control-switcher.switch-product-control': 'Przełącz kontrolę produktu',
  'app.components.simple-cycle.labels': `{labels, number} {labels, plural,
    one {Etykieta}
    few {Etykiety}
    many {Etykiet}
    other {Etykiet}
  }`,
  'app.components.simple-cycle.orders': `{orders, number} {orders, plural,
    one {Otwarte zamówienie}
    few {Otwarte zamówienia}
    many {Otwartych zamówień}
    other {Otwartych zamówień}
  }`,
  'app.components.simple-cycle.today': '{date}, Dzisiaj',
  'app.components.cycle-header.today': '{date}, Dzisiaj',
  'app.components.cycle-header.count': `{ count, number } {count, plural,
    one { zamówienie }
    few { zamówienia}
    many { zamówień}
    other { zamówień}
  }`,
  'app.components.cycle-header.label-items': 'Oznaczone przedmioty',
  'app.components.modal.close-button-aria-label': 'Zamknij modal',
  'app.components.product-item-controls.print': 'Drukuj',
  'app.components.cycle-order.consolidate': 'Konsoliduj',
  'app.components.order-consolidate-modal.consolidate': 'Konsoliduj',
  'app.components.order-consolidate-modal.button': 'Wybierz przedmioty, które chcesz skonsolidować',
  'app.components.order-consolidate-modal.consolidate-items': `Konsoliduj { amount, number } { amount, plural,
    one { przedmiot }
    few { przedmioty }
    many { przedmiotów }
    other { przedmiotów }
  }`,
  'app.components.product-decline-form.title': 'Powiedz nam powód',
  'app.components.product-decline-form.form-button': 'Ok',
  'app.components.product-quantity-selector.question': 'Ile możesz dostarczyć?',
  'app.components.product-quantity-selector.increase': 'Zwiększ ilość produktu',
  'app.components.product-quantity-selector.decrease': 'Zmniejsz ilość produktu',
  'app.components.product-quantity-selector.product-quantity': 'Ilość produktu',
  'app.components.change-order-status-button.move-ready-button': 'Przenieś do gotowych',
  'app.components.change-order-status-button.remove-button': 'Usuń z palety',
  'app.components.change-order-status-button.to-in-progress-button': 'Przenieś do w trakcie',
  'app.components.change-order-status-button.reason': 'Przeniesiono do W trakcie',
  'app.components.change-order-status-button.awaiting-final-po': 'Oczekiwanie na numer PO',
  'app.components.change-order-status-button.awaiting-final-po-tooltip': 'Odblokuje się po otrzymaniu numeru zamówienia zakupu',
  'app.components.change-order-status-button.final-po-received-toast': 'Zamówienie #{orderId} — można teraz wydrukować etykiety i przenieść zamówienie do Gotowych.',
  'app.components.product-item-controls.print-awaiting-final-po-tooltip': 'Etykieta zawiera finalne zamówienie zakupu — nie można drukować, dopóki nie zostanie otrzymane.',
  'app.components.time-status.ends': 'Kończy się',
  'app.components.time-status.cycle-ended': 'Cykl zakończony',
  'app.components.product-modal.unpack': 'Rozpakuj',
  'app.components.product-modal.print-label': 'Drukuj',
  'app.components.product-modal.re-print-label': 'Ponownie wydrukuj etykietę',
  'app.components.product-modal.unpack-to-detach': 'Rozpakuj, aby odłączyć od zamówienia',
  'app.components.product-decline-button.decline': 'Odrzuć',
  'app.components.product-decline-button.tooltip': 'Aby odrzucić, musisz najpierw rozpakować',
  'app.components.cycle-modal.ok': 'OK',
  'app.components.got-it.text': 'Rozumiem',
  'app.components.orders-columns.incoming': 'Przychodzące',
  'app.components.orders-columns.in-progress': 'W trakcie',
  'app.components.orders-columns.ready': 'Gotowe',
  'app.components.app-drawer.settings': 'Ustawienia',
  'app.components.app-drawer.language': 'Język',
  'app.components.app-drawer.printer': 'Drukarka',
  'app.components.app-drawer.label-format': 'Format etykiety',
  'app.components.app-drawer.label-format.zpl': 'Drukarka etykiet (4x4)',
  'app.components.app-drawer.label-format.pdf': 'Dokument PDF',
  'app.components.app-drawer.label-size': 'Rozmiar etykiety',
  'app.components.app-drawer.printer-connection': 'Połączenie',
  'app.components.app-drawer.printer-connection.auto': 'Automatycznie',
  'app.components.app-drawer.printer-connection.bluetooth': 'Bluetooth',
  'app.components.app-drawer.printer-connection.usb': 'Kabel USB',
  'app.components.app-drawer.printer-device': 'Drukarka',
  'app.components.app-drawer.printer-device.automatic': 'Pierwsza dostępna',
  'app.components.app-drawer.printer.dialog-title': 'Wybierz drukarkę',
  'app.components.app-drawer.printer.bluetooth': 'Bluetooth',
  'app.components.app-drawer.printer.allow-bluetooth': 'Zezwól na dostęp do Bluetooth',
  'app.components.app-drawer.printer.no-paired': 'Brak sparowanych drukarek. Najpierw sparuj drukarkę w ustawieniach Bluetooth systemu Android.',
  'app.components.app-drawer.printer.pair-new': 'Sparuj nową drukarkę',
  'app.components.app-drawer.printer.usb': 'Kabel USB',
  'app.components.app-drawer.printer.no-usb': 'Nie wykryto drukarki na kablu.',
  'app.components.app-drawer.printer.usb-ready': 'Gotowa ({deviceKey})',
  'app.components.app-drawer.printer.usb-unsupported': 'Nie nadaje się do drukowania ({deviceKey}, klasa {interfaceClasses})',
  'app.components.app-drawer.printer.usb-tap-to-allow': 'Naciśnij, aby zezwolić na dostęp',
  'app.components.app-drawer.printer.identify': 'Wykryj model i rozdzielczość drukarki',
  'app.components.app-drawer.printer.identifying': 'Wykrywanie…',
  'app.components.app-drawer.printer.refresh': 'Odśwież',
  'app.components.app-drawer.printer.done': 'Gotowe',
  'app.components.app-drawer.app-info': 'Informacje o aplikacji',
  'app.components.app-drawer.version': 'Wersja',
  'app.components.app-drawer.account': 'Konto',
  'app.components.app-drawer.logout': 'Wyloguj',
  'app.toasts.printer-not-disconnected': 'Drukarka nie została odłączona',
  'app.toasts.text-not-printing': 'Nie udało się wydrukować tekstu',
  'app.toasts.printer-not-connected': 'Drukarka nie jest podłączona',
  'app.toasts.bluetooth-disabled': 'Włącz Bluetooth',
  'app.toasts.printer-status-unknown': 'Nieznany status drukarki',
  'app.toasts.pdf-label-downloaded': 'Pobrano etykietę PDF. Otwórz i wydrukuj pobrany plik.',
  'app.toasts.printer-permission-denied': 'Odmówiono dostępu do drukarki. Zezwól na dostęp i spróbuj ponownie.',
  'app.toasts.printer-device-not-found': 'Nie znaleziono wybranej drukarki. Sprawdź, czy jest włączona i podłączona, lub wybierz inną w menu.',
  'app.toasts.native-pdf-print-unavailable': 'Ta wersja aplikacji nie może drukować etykiet PDF. Zaktualizuj aplikację lub zmień format etykiety z powrotem na drukarkę etykiet w menu.',
  'app.toasts.bluetooth-printer-unavailable': 'Drukarka etykiet Bluetooth nie jest tutaj dostępna. Zmień format etykiety na PDF w menu.',
  'app.toasts.print-error': 'Błąd drukowania: {error}',
  'app.toasts.print-error-unknown': 'Nieznany błąd',
  'app.components.notification-gate.title': 'Włącz powiadomienia',
  'app.components.notification-gate.body-prompt': 'Deliverider używa powiadomień, aby informować Cię o nowych zamówieniach. Powiadomienia są wymagane do zalogowania.',
  'app.components.notification-gate.body-denied': 'Powiadomienia są wyłączone i są wymagane do zalogowania. Włącz je, aby kontynuować:',
  'app.components.notification-gate.steps-ios': '1. Naciśnij „Otwórz ustawienia" poniżej\n2. Naciśnij „Powiadomienia"\n3. Włącz „Zezwalaj na powiadomienia"\n4. Wróć do tego ekranu',
  'app.components.notification-gate.steps-android': '1. Naciśnij „Otwórz ustawienia" poniżej\n2. Włącz „Zezwalaj na powiadomienia"\n3. Wróć do tego ekranu',
  'app.components.notification-gate.enable': 'Włącz powiadomienia',
  'app.components.notification-gate.open-settings': 'Otwórz ustawienia',
  'app.components.notification-gate.cancel': 'Anuluj',
  'app.notifications.order_created': 'Nowe zamówienie #{order_id}',
  'app.notifications.order_canceled': 'Zamówienie #{order_id} zostało anulowane',
  'app.notifications.item_canceled': 'Pozycja w zamówieniu #{order_id} została anulowana',
  'app.notifications.order_updated': 'Zamówienie #{order_id} zostało zaktualizowane',
  'app.notifications.order_status_incomplete': 'Zamówienie #{order_id} jest niekompletne',
  'app.notifications.order_not_delivered': 'Zamówienie #{order_id} nie zostało dostarczone',
  'app.notifications.order_acceptance_overdue': '⏰ Upłynął czas na akceptację zamówienia #{order_id}. Naciśnij, aby zaakceptować i zacznij przygotowywać je do odbioru, zanim zostanie przekazane komuś innemu.',
}